import React from 'react';
export function IntegrationsSection() {
  return <section className="w-full bg-page-bg py-20 md:py-24 px-5" data-id="element-93">
      <div className="max-w-6xl mx-auto" data-id="element-94">
        {/* Section badge */}
        <div className="flex justify-center mb-4" data-id="element-95">
          <span className="inline-block border rounded-full px-4 py-1 text-xs uppercase font-bold tracking-widest" style={{
          borderColor: '#FF4081',
          color: '#FF4081'
        }} data-id="element-96">
            INTEGRAZIONI
          </span>
        </div>

        {/* Heading */}
        <h2 className="font-heading font-bold text-3xl md:text-4xl text-navy text-center" data-id="element-97">
          Collega i tuoi{' '}
          <span style={{
          color: '#FF4081'
        }} data-id="element-98">
            calendari in un click.
          </span>
        </h2>

        {/* Pink underline accent */}
        <div className="flex justify-center mt-4" data-id="element-99">
          <div style={{
          width: '40px',
          height: '3px',
          background: '#FF4081',
          borderRadius: '2px'
        }} data-id="element-100" />
        </div>

        {/* Subtext */}
        <p className="font-body text-body-gray text-base md:text-lg mt-4 max-w-2xl mx-auto text-center leading-relaxed" data-id="element-101">
          CleanAI si integra con le principali piattaforme di prenotazione e
          channel manager. I tuoi check-in e check-out vengono sincronizzati
          automaticamente.
        </p>

        {/* Piattaforme group */}
        <div className="mt-12" data-id="element-102">
          <p className="font-heading font-semibold text-sm uppercase tracking-widest text-navy text-center mb-6" data-id="element-103">
            Piattaforme
          </p>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6 max-w-3xl mx-auto" data-id="element-104">
            {/* Airbnb */}
            <div className="bg-white border-2 border-gray-100 rounded-none p-6 md:p-8 flex items-center justify-center" data-id="element-105">
              <img src="https://cdn.magicpatterns.com/uploads/45osBDDkw5i3k6hcKGSonU/Airbnb_Logo_Belo.svg.png" alt="Airbnb" className="max-h-[32px] md:max-h-[40px] w-auto object-contain" data-id="element-106" />
            </div>

            {/* Booking.com */}
            <div className="bg-white border-2 border-gray-100 rounded-none p-6 md:p-8 flex items-center justify-center" data-id="element-107">
              <img src="https://cdn.magicpatterns.com/uploads/ijk4oeZxCmpT9Dz9oUV6v7/Booking.com_Logo.svg.png" alt="Booking.com" className="max-h-[28px] md:max-h-[36px] w-auto object-contain" data-id="element-108" />
            </div>

            {/* Expedia */}
            <div className="bg-white border-2 border-gray-100 rounded-none p-6 md:p-8 flex items-center justify-center col-span-2 md:col-span-1" data-id="element-109">
              <img src="https://cdn.magicpatterns.com/uploads/fdGE9gSnABfyVQRMznYuKj/Expedia-Horizontal-Logo-Product-Full-Colour-Dark-Blue-RGB.png" alt="Expedia" className="max-h-[32px] md:max-h-[40px] w-auto object-contain" data-id="element-110" />
            </div>
          </div>
        </div>

        {/* Channel Manager group */}
        <div className="mt-10" data-id="element-111">
          <p className="font-heading font-semibold text-sm uppercase tracking-widest text-navy text-center mb-6" data-id="element-112">
            Channel Manager
          </p>
          <div className="grid grid-cols-2 gap-4 md:gap-6 max-w-xl mx-auto" data-id="element-113">
            {/* Smoobu */}
            <div className="bg-white border-2 border-gray-100 rounded-none p-6 md:p-8 flex items-center justify-center" data-id="element-114">
              <img src="https://cdn.magicpatterns.com/uploads/w3GDjcR2RsaqPygBAaWFbb/68c1308e367bcd541b966254_Smoobu_logo_blue_h.svg" alt="Smoobu" className="max-h-[28px] md:max-h-[36px] w-auto object-contain" data-id="element-115" />
            </div>

            {/* Lodgify */}
            <div className="bg-white border-2 border-gray-100 rounded-none p-6 md:p-8 flex items-center justify-center" data-id="element-116">
              <img src="https://cdn.magicpatterns.com/uploads/2qJqt7c2yXUjyFsbXdDaZj/Lodgify-Integration.jpg" alt="Lodgify" className="max-h-[32px] md:max-h-[40px] w-auto object-contain" data-id="element-117" />
            </div>
          </div>
        </div>

        {/* Callout */}
        <div className="mt-10 max-w-3xl mx-auto text-center" data-id="element-118">
          <p className="font-body md:text-[15px] text-[16px]" style={{
          color: '#FF4081'
        }} data-id="element-119">
            <span className="inline-block w-2 h-2 rounded-full mr-2 align-middle" style={{
            background: '#FF4081'
          }} data-id="element-120" />
            Colleghi una volta, e CleanAI sa sempre quando arrivano i tuoi
            ospiti.
          </p>
        </div>
      </div>
    </section>;
}